module.exports = __webpack_public_path__ + "img/avatar.ce9fd5cc.png";